<template>
  <div class="text-center">
    <v-btn
      class="ml-2"
      min-width="0"
      color="third"
      exact
      depressed
    >
      Publish
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'DefaultUpgrade',
  }
</script>
